<template>
  <div class="flex-1 relative overflow-y-auto">
    <slot></slot>
  </div>
</template>